//
//
//
//
//
//

export default {
  name: 'm-primary-btn',
  props: ['text', 'status'],
  methods: {
    clickHandler () {
      this.$emit('click')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PrimaryBtn.vue